<template>
  <div class="spells">
    <shell>
      <div class="container m-auto">
        <div class="w-full lg:w-1/2 m-auto px-2 pb-4">
          <h2 class="text-2xl">Spells <a target="_blank" href="https://www.tatatap.com/spells" class="text-xs font-normal">About</a></h2>
        </div>
      </div>
      <div class="container m-auto">
        <div class="w-full lg:w-1/2 m-auto px-2">

          <div v-if="pigs && (pigs.scheduled || pigs.apis )">
            <div v-if="pigs.scheduled && pigs.scheduled.length" class="pb-10">

              <div class="text-lg pb-6 font-bold">Schedule</div>

              <router-link :to="'/spells/' + p.id" v-for="p in pigs.scheduled" class="p-2 bg-black rounded mb-4 block text-black no-underline">
                <div
                  class="flex justify-between align-center py-4">
                  <query-name :fn="p.fn"
                    :frequency="p.mode"
                    :startDate="p.start_from" />
                </div>
              </router-link>
            </div>

            <div v-if="pigs.apis && pigs.apis.length">
              <div class="pb-6">
                <div class="text-lg pb-2 font-bold">APIs</div>
                <div class="text-sm">To learn about how to use the /tap API see <a href="https://www.tatatap.com/api-documentation">the documentation</a></div>
              </div>


              <div class="pb-10">
                <div class="p-2 bg-black rounded mb-4"  v-for="api in pigs.apis">
                  <router-link :to="'/spells/api/' + api.id" class="block no-underline">
                    <div class="py-4">
                      <div class="pb-4 text-base font-bold text-white">Notes API</div>
                      <div class="rounded text-sm text-white bg-black">
                        <div class="pb-2">
                          Using folder <span class="font-bold font-mono path text-black bg-light-yellow">
                          {{api.folder}}
                          </span>
                        </div>
                        <div class="text-xs font-bold">
                          <span v-if="api.is_readonly">
                            This API can only read notes in {{api.folder}}
                          </span>
                          <span v-else>
                            This API can <strong>read, create, update and delete</strong> notes in {{api.folder}}
                          </span>
                        </div>
                      </div>
                    </div>
                  </router-link>

                  <div class="border-t border-white text-white pt-4">
                    <div class="pb-4">
                      <div class="text-xs pb-2">API URL</div>
                      <div class="text-xs font-mono font-bold">{{server}}/notes/v1/{{api.short_id}}</div>
                    </div>
                    <div class="pb-4">
                      <div class="text-xs pb-2">API Key</div>
                      <div class="text-xs font-mono font-bold">{{api.key}}</div>
                    </div>
                  </div>

                </div>
              </div>

            </div>
          </div>
          <div v-else>
            <p class="text-sm font-normal leading-normal">You don't have any Spells running.</p>

          </div>
        </div>
      </div>

      <div class="container m-auto">
        <div class="w-full lg:w-1/2 m-auto px-2">
          <div class="text-lg pb-6 font-bold">Add New Spell</div>
          <spell-bar  />
        </div>
      </div>
    </shell>

  </div>
</template>

<script>
 import {mapState, mapActions} from 'vuex';
 import api from '@/api';
 import Shell from '@/components/Shell';
 import SpellBar from '@/components/SpellBar';
 import {DateTime} from 'luxon';
 import QueryName from '@/components/QueryName';

 export default {
   components: {Shell, QueryName, SpellBar},
   data () {
     return {
       server: process.env.VUE_APP_API_URL,
       isCreateModalVisible: false,
       isEditModalVisible: false,
       pigError: ''
     }
   },

   computed: mapState({
     pigs: state => state.pigs
   }),

   created () {
     this.getPigs();
   },

   methods: {
     ...mapActions(['getPigs'])
   }
 }
</script>
